/**
 * PinkyHat confession wall — reveal, hover glow, and expandable review cards.
 */
(function () {
  if (!window.customElements.get('wof-card')) {
    window.customElements.define('wof-card', class WofCard extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.abortController = new AbortController();

        this.addEventListener('pointermove', this.updateGlow.bind(this), { signal: this.abortController.signal });

        this.querySelectorAll('[data-expand]').forEach((button) => {
          button.addEventListener('click', () => this.toggleBody(button), { signal: this.abortController.signal });
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      updateGlow(event) {
        const rect = this.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        this.style.setProperty('--mouse-x', `${x}%`);
        this.style.setProperty('--mouse-y', `${y}%`);
      }

      toggleBody(button) {
        const body = this.querySelector('[data-slot="body"]');
        const buttonText = button.querySelector('.wof-expand-btn__text');
        if (!body || !buttonText) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        const nextText = nextExpanded ? body.dataset.fullText : body.dataset.truncatedText;
        const nextLabel = nextExpanded ? button.dataset.collapseLabel : button.dataset.expandLabel;

        body.textContent = nextText || '';
        buttonText.textContent = nextLabel || '';
        button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      }
    });
  }

  if (!window.customElements.get('wof-grid')) {
    window.customElements.define('wof-grid', class WofGrid extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.abortController = new AbortController();
        this.revealTargets = Array.from(this.querySelectorAll('.wof-section-head, .wof-card-wrap'));
        this.floatTargets = Array.from(this.querySelectorAll('.wof-cta-float, .wof-count-badge'));
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.prefersReducedMotion || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
          this.revealAll();
        } else {
          this.observeRevealTargets();
        }

        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this), { signal: this.abortController.signal });
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      observeRevealTargets() {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

        this.revealTargets.forEach((target) => this.observer.observe(target));

        if (this.floatTargets.length > 0) {
          const floatObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.floatTargets.forEach((target) => target.classList.add('is-visible'));
              floatObserver.disconnect();
            });
          }, { rootMargin: '0px 0px -35% 0px', threshold: 0 });

          floatObserver.observe(this);
          this.abortController.signal.addEventListener('abort', () => floatObserver.disconnect(), { once: true });
        }
      }

      revealAll() {
        this.revealTargets.forEach((target) => target.classList.add('is-visible'));
        this.floatTargets.forEach((target) => target.classList.add('is-visible'));
      }

      handleBlockSelect(event) {
        const selectedBlock = event.target.closest('[data-shopify-editor-block]');
        if (!selectedBlock) return;

        selectedBlock.classList.add('is-visible');
        selectedBlock.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
      }
    });
  }
})();
